"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

type IntercomSettings = { api_base: string; app_id: string };
type IntercomWindow = Window & {
  intercomSettings?: IntercomSettings;
  Intercom?: (command: string, settings?: IntercomSettings) => void;
};

export default function IntercomClientComponent() {
  const pathname = usePathname();

  useEffect(() => {
    const appId = process.env.NEXT_PUBLIC_INTERCOM_APP_ID?.trim();
    if (!appId || pathname.includes("/studio")) return;

    const intercomWindow = window as IntercomWindow;
    const settings = { api_base: "https://api-iam.intercom.io", app_id: appId };
    intercomWindow.intercomSettings = settings;

    if (intercomWindow.Intercom) {
      intercomWindow.Intercom("reattach_activator");
      intercomWindow.Intercom("update", settings);
      return;
    }
    if (document.getElementById("tradestats-intercom")) return;

    const script = document.createElement("script");
    script.id = "tradestats-intercom";
    script.async = true;
    script.src = `https://widget.intercom.io/widget/${encodeURIComponent(appId)}`;
    script.onload = () => {
      intercomWindow.Intercom?.("update", intercomWindow.intercomSettings);
    };
    document.body.appendChild(script);
  }, [pathname]);

  return null;
}
